import '../../../utils/index2.mjs';
import { buildProps, definePropType } from '../../../utils/vue/props/runtime2.mjs';

const iconProps = buildProps({
  size: {
    type: definePropType([Number, String])
  },
  color: {
    type: String
  }
});

export { iconProps };
//# sourceMappingURL=icon3.mjs.map
